module.exports = __webpack_public_path__ + "static/background_heading-5d07a9709b2cd6a4298670a1a05974d7.jpg";